// extracted by mini-css-extract-plugin
export default {"emptyList":"UsersListPage_emptyList__ExzLh"};